import GamecenterPlayerCard from '../../../player/components/GamecenterPlayerCard/GamecenterPlayerCard';
import isPlayerInfoUpcoming from '../../../player/utils/isPlayerInfoUpcoming';
import type { PlayerPick } from '../../../player/types/playerPick';

export function renderPlayerCardVariant(pick: PlayerPick) {
  if (!pick.playerInfo) {
    return pick.isUpcomingPlaceholder ? (
      <GamecenterPlayerCard.UpcomingPlaceholder tierId={pick.tier.id} position={pick.tier.label} />
    ) : (
      <GamecenterPlayerCard.EmptyPick tierId={pick.tier.id} position={pick.tier.label} />
    );
  }

  if (isPlayerInfoUpcoming(pick.playerInfo)) {
    return <GamecenterPlayerCard.Upcoming {...pick.playerInfo} />;
  }
  return <GamecenterPlayerCard.AfterGameStart {...pick.playerInfo} />;
}
